/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['./reachableRange'], function(reachableRangeModel) {
    'use strict';

    return function(data) {
        if (!Array.isArray(data.batchItems)) {
            return null;
        }
        return data.batchItems.map(function(batchItem) {
            if (batchItem.response.error) {
                return { error: batchItem.response.error};
            } else {
                return reachableRangeModel(batchItem.response);
            }
        });
    };
});



// WEBPACK FOOTER //
// ./model/routing/batchReachableRange.js